export * from './app-aside.component';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/components/app-aside/index.ts